<template>
  <div class="time-picker">
    <p4a-button :showIcon="true"
                :onlyIconVisible="true"
                :icon="'time'"
                :size="'small'"
                @click="showSelector">
    </p4a-button>
    <p4a-popover class="time-picker__container"
                 v-if="visible"
                 :width="popoverWidth"
                 :height="popoverHeight"
                 :eventObject="currentTarget"
                 :align="'left'"
                 :center="centerPopover"
                 :isArrowNeeded="topArrow"
                 :isBackgroundRequired="popoverBackground"
                 @close="visible = false">
      <div class="time-picker__hour">
        <span class="time-picker__title">Uren</span>
        <ul class="time-picker__list">
          <li class="time-picker__value"
              v-for="hour in hours"
              :key="hour.value"
              @click="[activeHour = hour.value, updateTime()]"
              :class="{'time-picker__value--active-hour':activeHour === hour.value}">
            {{ hour.value }}
          </li>
        </ul>
      </div>
      <div class="time-picker__minute">
        <span class="time-picker__title">Minuten</span>
        <ul class="time-picker__list">
          <li class="time-picker__value"
              v-for="minute in minutes"
              :key="minute.value"
              @click="[activeMinute = minute.value, updateTime()]"
              :class="{'time-picker__value--active-minute':activeMinute === minute.value}">
            {{ minute.value }}
          </li>
        </ul>
      </div>
    </p4a-popover>
  </div>
</template>

<script>
  import _ from 'lodash'

  export default {
    name: 'Timepicker',
    props: {
      popoverWidth: Number,
      popoverHeight: Number,
      centerPopover: Boolean,
      topArrow: Boolean,
      popoverBackground: Boolean,
      eventObject: MouseEvent,
      inputTime: Object
    },
    inheritAttrs: true,
    created () {
      this.activeHour = (this.inputTime) ? this.inputTime.activeHour : '00'
      this.activeMinute = (this.inputTime) ? this.inputTime.activeMinute : '00'
      this.currentTarget = _.clone(this.eventObject)
    },
    data () {
      return {
        visible: false,
        activeHour: '',
        activeMinute: '',
        currentTarget: null,
        time: this.value,
        hours: [
          { value: '01' },
          { value: '02' },
          { value: '03' },
          { value: '04' },
          { value: '05' },
          { value: '06' },
          { value: '07' },
          { value: '08' },
          { value: '09' },
          { value: '10' },
          { value: '11' },
          { value: '12' },
          { value: '13' },
          { value: '14' },
          { value: '15' },
          { value: '16' },
          { value: '17' },
          { value: '18' },
          { value: '19' },
          { value: '20' },
          { value: '21' },
          { value: '22' },
          { value: '23' },
          { value: '24' }
        ],
        minutes: [
          { value: '00' },
          { value: '05' },
          { value: '10' },
          { value: '15' },
          { value: '20' },
          { value: '25' },
          { value: '30' },
          { value: '35' },
          { value: '40' },
          { value: '45' },
          { value: '50' },
          { value: '55' }
        ]
      }
    },
    methods: {
      showSelector () {
        let self = this
        self.visible = self.visible === false
        self.currentTarget = (self.visible) ? event : null
      },
      updateTime () {
        let self = this
        if (self.activeHour !== null && self.activeMinute !== null) {
          self.$emit('updateTime', { activeTime: self.activeHour + ':' + self.activeMinute })
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

  @import '../styling/styling.scss';

  .time-picker {
    position: relative;
    width: fit-content;

    &__container {
      height: auto;
      border-radius: rem(2);
      background-color: $white;
    }

    &__title {
      width: 100%;
      height: rem(25);
      display: block;
      font-weight: 400;
      text-align: center;
      font-size: rem(13);
      line-height: rem(25);
      margin-bottom: rem(8);
      color: $light-grey-font;
    }

    &__hour, &__minute {
      z-index: 1500;
      position: relative;
      background-color: $white;
    }

    &__hour { padding: rem(10) rem(15) 0 rem(15); }

    &__minute { padding: 0 rem(15) rem(10) rem(15); }

    &__value {
      width: rem(25);
      height: rem(25);
      float: left;
      list-style: none;
      font-weight: 400;
      @extend %animate;
      border-radius: 50%;
      font-size: rem(13);
      text-align: center;
      line-height: rem(25);
      color: $dark-grey-font;
      margin: 0 rem(10) rem(8) 0;

      &:hover {
        cursor: pointer;
        @extend %animate;
        background-color: $medium-grey-background;
      }

      &:nth-child(6n) { margin: 0; }

      &--active-hour, &--active-minute {
        color: $white;
        background-color: $pending-blue;

        &:hover {
          color: $white;
          cursor: pointer;
          background-color: $pending-blue;
        }
      }
    }

    &__list {
      width: 100%;
      margin: 0;
      padding: 0;
      display: inline-block;
    }
  }

</style>



// WEBPACK FOOTER //
// node_modules/pro4all-ui/ui-kit/components/Timepicker.vue